export const TASK_FINISH_STATUS_COMPLETED = 'completed';
export const TASK_FINISH_STATUS_FAILED = 'failed';

export const TASK_EVENT_TYPE_RESULT = 'TaskEventResult';
export const TASK_EVENT_TYPE_STEP_RESULT = 'TaskEventStepResult';
